import { Container } from '../../../../components/Container/Container';
import { NonNullEdge } from '../../../../helpers/graphql';
import {
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges,
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges_node,
} from '../../../../interfaces/graphql';
import { BitetimeDownloadSection } from '../../../../components/BitetimeDownloadSection/BitetimeDownloadSection';
import { DYNAMIC_TOP_SPECIES } from '../../../../components/BitetimeDownloadSection/constants/constants';

interface IBitetimeSectionProps {
  fishingWaterName: string;
  speciesEdges: (GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges &
    NonNullEdge<GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges_node>)[];
}

export const BitetimeSection = ({ fishingWaterName, speciesEdges }: IBitetimeSectionProps) => {
  const topSpeciesList = speciesEdges.map(({ node: { _id: id, displayName: label } }) => ({
    id,
    label,
  }));

  const dynamicTopSpeciesArray = topSpeciesList.flatMap(topSpecies => {
    const dynamicTopSpeciesFound = DYNAMIC_TOP_SPECIES.find(species => {
      return topSpecies.id === species.externalID;
    });
    if (dynamicTopSpeciesFound) {
      return dynamicTopSpeciesFound;
    }
    return [];
  });

  const dynamicTopSpecies = dynamicTopSpeciesArray.length > 0 && dynamicTopSpeciesArray[0];

  if (!dynamicTopSpecies) {
    return <></>;
  }

  return (
    <Container className="mb-fw sm:mt-md md:grid md:grid-cols-12">
      <BitetimeDownloadSection
        title={`When is the ${dynamicTopSpecies.speciesName} biting in ${fishingWaterName}?`}
        text={`Learn what hours to go fishing at ${fishingWaterName}. Download the app today and get started looking for fishing spots, prepare for your next fishing trip, and try out our BiteTime™ feature, explore fishing spots, and save relevant baits to prepare for your next fishing trip.`}
        topSpecies={dynamicTopSpecies}
      />
    </Container>
  );
};
